import { render } from "./ExampleDeviceScreenBitcoin.vue?vue&type=template&id=b229a2a6&scoped=true&ts=true&lang=pug"
import script from "./ExampleDeviceScreenBitcoin.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExampleDeviceScreenBitcoin.vue?vue&type=script&lang=ts&setup=true"

import "./ExampleDeviceScreenBitcoin.vue?vue&type=style&index=0&id=b229a2a6&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b229a2a6"]])

export default __exports__